/**
 * Catálogo de informes del hub: metadatos de UI y handler (archivo por familia).
 * La lista clicable está en reportHub-page.html; aquí solo se resuelve la definición por reportId.
 */

const REPORT_DEFINITIONS = [
  {
    id: "account-receivable-all",
    handler: "customer",
    label: "Accounts receivable — all customers",
    description:
      "Aging summary for every customer (same data as Accounts Receivable page).",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
  },
  {
    id: "account-payable-all",
    handler: "provider",
    label: "Accounts payable — all providers",
    description:
      "Aging summary for every provider (same data as Accounts Payable page).",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
  },
  {
    id: "account-receivable-one",
    handler: "customer",
    label: "Accounts receivable — one customer",
    description:
      "Aging detail and unpaid invoices for a single customer (same layout as Accounts Receivable → one customer).",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    id: "account-payable-one",
    handler: "provider",
    label: "Accounts payable — one provider",
    description:
      "Aging detail and unpaid bills for a single provider (same layout as Accounts Payable → one provider).",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
];

export function getReportDefinition(reportId) {
  return REPORT_DEFINITIONS.find((r) => r.id === reportId);
}

export function getAllReportDefinitions() {
  return REPORT_DEFINITIONS.slice();
}
